interface ChipWithCheckmarkSquareSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ChipWithCheckmarkSquareSVG = ({
  color,
  style,
}: ChipWithCheckmarkSquareSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
  >
    <g clipPath="url(#clip0_3339_65441)">
      <path
        d="M19.977 22.0322C19.7753 22.0322 19.5888 21.9256 19.4861 21.7544L18.238 19.6577C18.0782 19.3876 18.1657 19.0375 18.4359 18.8739C18.706 18.714 19.0561 18.8016 19.2197 19.0717L19.977 20.3465L21.4267 17.9188C21.5865 17.6486 21.9404 17.5611 22.2106 17.7209C22.4808 17.8807 22.5683 18.2346 22.4085 18.5048L20.4678 21.7544C20.3651 21.9256 20.1786 22.0322 19.977 22.0322Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M29.0635 29.6578H11.1411C10.8253 29.6578 10.5703 29.4028 10.5703 29.087V11.1684C10.5703 10.8526 10.8253 10.5977 11.1411 10.5977H29.0635C29.3793 10.5977 29.6342 10.8526 29.6342 11.1684V29.0908C29.6342 29.4066 29.3793 29.6616 29.0635 29.6616V29.6578ZM11.7119 28.5162H28.4927V11.7392H11.7119V28.52V28.5162Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M7.14912 7.72087H0.760229C0.4444 7.72087 0.189453 7.46592 0.189453 7.1501V0.761206C0.189453 0.445376 0.4444 0.19043 0.760229 0.19043H7.14912C7.46495 0.19043 7.71989 0.445376 7.71989 0.761206V7.1501C7.71989 7.46592 7.46495 7.72087 7.14912 7.72087ZM1.33101 6.57932H6.57834V1.33198H1.33101V6.57932Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M39.4089 7.72087H33.02C32.7042 7.72087 32.4492 7.46592 32.4492 7.1501V0.761206C32.4492 0.445376 32.7042 0.19043 33.02 0.19043H39.4089C39.7247 0.19043 39.9797 0.445376 39.9797 0.761206V7.1501C39.9797 7.46592 39.7247 7.72087 39.4089 7.72087ZM33.5908 6.57932H38.8381V1.33198H33.5908V6.57932Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M7.15498 39.8097H0.766089C0.450259 39.8097 0.195312 39.5548 0.195312 39.239V32.8501C0.195312 32.5342 0.450259 32.2793 0.766089 32.2793H7.15498C7.47081 32.2793 7.72575 32.5342 7.72575 32.8501V39.239C7.72575 39.5548 7.47081 39.8097 7.15498 39.8097ZM1.33686 38.6682H6.5842V33.4208H1.33686V38.6682Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M39.4147 39.8097H33.0259C32.71 39.8097 32.4551 39.5548 32.4551 39.239V32.8501C32.4551 32.5342 32.71 32.2793 33.0259 32.2793H39.4147C39.7306 32.2793 39.9855 32.5342 39.9855 32.8501V39.239C39.9855 39.5548 39.7306 39.8097 39.4147 39.8097ZM33.5966 38.6682H38.844V33.4208H33.5966V38.6682Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M29.2095 11.5183C29.0649 11.5183 28.9165 11.4612 28.8062 11.3508C28.5854 11.1263 28.5854 10.7648 28.8062 10.5441L32.6189 6.74658C32.8434 6.52588 33.2049 6.52588 33.4256 6.74658C33.6463 6.97109 33.6463 7.33258 33.4256 7.55328L29.6128 11.3508C29.5025 11.4612 29.3541 11.5183 29.2095 11.5183Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M32.988 33.5577C32.8434 33.5577 32.695 33.5007 32.5847 33.3903L28.7719 29.5927C28.5474 29.372 28.5474 29.0106 28.7719 28.7861C28.9926 28.5615 29.3541 28.5615 29.5786 28.7861L33.3914 32.5836C33.6159 32.8043 33.6159 33.1658 33.3914 33.3903C33.281 33.5007 33.1326 33.5577 32.988 33.5577Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M10.906 11.5182C10.7614 11.5182 10.613 11.4611 10.5026 11.3508L6.68986 7.5532C6.46536 7.3325 6.46536 6.97101 6.68986 6.7465C6.91056 6.522 7.27206 6.522 7.49656 6.7465L11.3093 10.5441C11.5339 10.7648 11.5339 11.1263 11.3093 11.3508C11.199 11.4611 11.0506 11.5182 10.906 11.5182Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M7.12356 33.5578C6.97896 33.5578 6.83056 33.5007 6.72021 33.3904C6.49951 33.1659 6.49951 32.8044 6.72021 32.5837L10.533 28.7861C10.7575 28.5654 11.119 28.5654 11.3397 28.7861C11.5604 29.0106 11.5604 29.3721 11.3397 29.5928L7.52691 33.3904C7.41656 33.5007 7.26816 33.5578 7.12356 33.5578Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M20.0884 11.5181C19.7725 11.5181 19.5176 11.2631 19.5176 10.9473V6.42673C19.5176 6.1109 19.7725 5.85596 20.0884 5.85596C20.4042 5.85596 20.6591 6.1109 20.6591 6.42673V10.9473C20.6591 11.2631 20.4042 11.5181 20.0884 11.5181Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M20.0689 6.57927C18.623 6.57927 17.4434 5.40347 17.4434 3.9537C17.4434 2.50392 18.6192 1.32812 20.0689 1.32812C21.5187 1.32812 22.6945 2.50392 22.6945 3.9537C22.6945 5.40347 21.5187 6.57927 20.0689 6.57927ZM20.0689 2.47348C19.2508 2.47348 18.5849 3.13939 18.5849 3.9575C18.5849 4.77561 19.2508 5.44152 20.0689 5.44152C20.887 5.44152 21.5529 4.77561 21.5529 3.9575C21.5529 3.13939 20.887 2.47348 20.0689 2.47348Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M20.0884 34.4062C19.7725 34.4062 19.5176 34.1513 19.5176 33.8355V29.3149C19.5176 28.9991 19.7725 28.7441 20.0884 28.7441C20.4042 28.7441 20.6591 28.9991 20.6591 29.3149V33.8355C20.6591 34.1513 20.4042 34.4062 20.0884 34.4062Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M20.0689 38.9347C18.623 38.9347 17.4434 37.7589 17.4434 36.3092C17.4434 34.8594 18.6192 33.6836 20.0689 33.6836C21.5187 33.6836 22.6945 34.8594 22.6945 36.3092C22.6945 37.7589 21.5187 38.9347 20.0689 38.9347ZM20.0689 34.829C19.2508 34.829 18.5849 35.4949 18.5849 36.313C18.5849 37.1311 19.2508 37.797 20.0689 37.797C20.887 37.797 21.5529 37.1311 21.5529 36.313C21.5529 35.4949 20.887 34.829 20.0689 34.829Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M33.7749 20.7231H29.2544C28.9385 20.7231 28.6836 20.4681 28.6836 20.1523C28.6836 19.8365 28.9385 19.5815 29.2544 19.5815H33.7749C34.0907 19.5815 34.3457 19.8365 34.3457 20.1523C34.3457 20.4681 34.0907 20.7231 33.7749 20.7231Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M36.2447 22.759C34.7987 22.759 33.6191 21.5832 33.6191 20.1334C33.6191 18.6836 34.7949 17.5078 36.2447 17.5078C37.6945 17.5078 38.8703 18.6836 38.8703 20.1334C38.8703 21.5832 37.6945 22.759 36.2447 22.759ZM36.2447 18.6532C35.4266 18.6532 34.7607 19.3191 34.7607 20.1372C34.7607 20.9553 35.4266 21.6212 36.2447 21.6212C37.0628 21.6212 37.7287 20.9553 37.7287 20.1372C37.7287 19.3191 37.0628 18.6532 36.2447 18.6532Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M10.8862 20.7231H6.3657C6.04987 20.7231 5.79492 20.4681 5.79492 20.1523C5.79492 19.8365 6.04987 19.5815 6.3657 19.5815H10.8862C11.2021 19.5815 11.457 19.8365 11.457 20.1523C11.457 20.4681 11.2021 20.7231 10.8862 20.7231Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M3.89315 22.759C2.44718 22.759 1.26758 21.5832 1.26758 20.1334C1.26758 18.6836 2.44338 17.5078 3.89315 17.5078C5.34292 17.5078 6.51872 18.6836 6.51872 20.1334C6.51872 21.5832 5.34292 22.759 3.89315 22.759ZM3.89315 18.6532C3.07504 18.6532 2.40913 19.3191 2.40913 20.1372C2.40913 20.9553 3.07504 21.6212 3.89315 21.6212C4.71126 21.6212 5.37717 20.9553 5.37717 20.1372C5.37717 19.3191 4.71126 18.6532 3.89315 18.6532Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_3339_65441">
        <rect width="40.175" height="40" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ChipWithCheckmarkSquareSVG;
